import React from 'react'
import "./Successfullmodal.css"
import { Modal } from "react-bootstrap";
import Successfull_lottie from './successfull_lottie/Successfull_lottie';

export default function Successfullmodal(props) {
    const { message } = props;
    return (
        <>
            <div className="Successfull_Modal_sec">
                <Modal
                    className="Successfull_Modal"
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className="lottie-holder">
                            {" "}
                            <Successfull_lottie />
                        </div>
                        <p>{message}</p> {/* Displaying the 'message' prop */}
                    </Modal.Body>
                </Modal>
            </div>

        </>
    )
}
